// Prevent pinch-zoom on mobile devices
window.initMobileUtils = function initMobileUtils() {
    document.addEventListener('gesturestart', function (e) {
        e.preventDefault();
    });
    document.addEventListener('gesturechange', function (e) {
        e.preventDefault();
    });
    document.addEventListener('gestureend', function (e) {
        e.preventDefault();
    });
}

// Initialize mobile utils immediately
initMobileUtils();
